import { render, staticRenderFns } from "./ConfigRole.vue?vue&type=template&id=ed01a87e&scoped=true&"
import script from "./ConfigRole.vue?vue&type=script&lang=js&"
export * from "./ConfigRole.vue?vue&type=script&lang=js&"
import style0 from "./ConfigRole.vue?vue&type=style&index=0&id=ed01a87e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed01a87e",
  null
  
)

export default component.exports